import Swiper from "swiper";
import { Pagination, A11y, Autoplay } from "swiper/modules";

/**
 * Initializes all Swiper sliders for quotes on the page.
 */
export function initializeQuotesSliders(): void {
  document.addEventListener("DOMContentLoaded", () => {
    // Target all quotes sliders (multi-column, one-column, etc.)
    const sliders: NodeListOf<Element> = document.querySelectorAll(
      ".quotes-slider.swiper-container"
    );

    sliders.forEach((slider) => {
      if (slider instanceof HTMLElement) {
        console.log("slider in loop here", slider);

        // Optionally, you can read data attributes for custom options
        let slidesToShow = parseInt(
          slider.getAttribute("data-slides-to-show") || "1",
          10
        );
        const slideCount = parseInt(
          slider.getAttribute("data-count") || "1",
          10
        );

        console.log({ slider, slidesToShow, slideCount });

        if (slideCount < slidesToShow) {
          slidesToShow = slideCount;
        }
        new Swiper(slider, {
          loop: true,
          modules: [Pagination, A11y, Autoplay],
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          autoplay: false,
          a11y: { enabled: true },
          speed: 700,
          effect: "slide",
          breakpoints: {
            750: {
              slidesPerView: slidesToShow,
              slidesPerGroup: slidesToShow,
            },
            0: {
              slidesPerView: 1,
              slidesPerGroup: 1,
            },
          },
        });
      }
    });
  });
}
